//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Field } from 'redux-form';
import ContainerRowReduxTextField from '../../components/common/ContainerRowReduxTextField'
import ContainerRowReduxCheckboxField from '../ProjectDemeter/common/ContainerRowReduxCheckboxField'
import ContainerRowError from '../../components/common/ContainerRowError'
import ContainerRowReduxAutoCompleteAndOverrideField from '../../components/common/ContainerRowReduxAutoCompleteAndOverrideField'
import ContainerRowReduxSmartTextReadonlyField from '../../components/common/ContainerRowReduxSmartTextReadonlyField'
import RFSelectField from '../../components/ReduxFormComps/RFSelectField';
import * as actions from '../../redux/selene/actions';
import * as actConfDlgActions from '../../redux/actConfDialog/actions';
import type { ReducerState$Type } from '../../redux/genericFlowTypes';
import type { InvoiceHeaderForm$Props } from './flowTypes'

const styles = {
    locationTextFieldStyle: {
        width: '270px',
        paddingBottom: '10px'
    },
}

const renderSubmitButton=(props:InvoiceHeaderForm$Props)=>{
    const { pristine,submitting,isInvalidDoc,invalid } = (props:any);
    const submitOpenActionDialog = (props.submitOpenActionDialog:any)
    const selene:ReducerState$Type = (props.selene:any)
    
    if (isInvalidDoc && Object.keys(selene.formError).length == 0){
        return <button type="button" onClick={()=> submitOpenActionDialog()} className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit As Invalid Invoice</button>; 
    }else {
        return (
            <div>
                <button type="button" onClick={()=> submitOpenActionDialog()} 
                className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit Your Answer</button>
            </div>    
        )
    }
}

const vendorNameField='vendorName'
const vendorIdField='vendorId'
const invNoField='invNo'
const invDateField='invDate'
const poNoField='poNo'
const acctNoField='acctNo'
const projectNoField='projectNo'
const termsField='terms'
const taxField='tax'
const additionalField='additional'
const totalField='total'

const vendorAutoCompleteDataSourceConfig = {
    text: vendorNameField,
    value: vendorNameField
}

const processVendorIdByVendorName=(vendorName:string,props: InvoiceHeaderForm$Props)=>{
    const changeFieldValue = (props.changeFieldValue:any)

    if (vendorName){
        const vendors = props.selene.vendors
        if (vendors && vendorName){
            let search = vendors.find(v=>v.vendorName===vendorName);
            if (search){
                changeFieldValue(vendorIdField,search[vendorIdField])
            }
        }else {
            changeFieldValue(vendorIdField,'')
        }
    }else {
        changeFieldValue(vendorIdField,'')
    }
}

class InvoiceHeaderForm extends React.Component<InvoiceHeaderForm$Props> {
    
    refreshEditData(){
        if (this.props.isVerifyMode){
            const getTaskData = (this.props.getTaskData:any)
            getTaskData(this.props.jwt,this.props.taskAcceptedInfoId)
        }
    }

    componentWillMount(){
        const { jwt, selene } = this.props
        if (!selene.vendorsLoaded){
            const populateVendorsList=(this.props.populateVendorsList:any)
            populateVendorsList(jwt);
        }
    }
    
    componentDidUpdate(prevProps: InvoiceHeaderForm$Props){
        //VendorName props checking
        const prevVendorName = (prevProps.vendorName:any)
        const vendorName = (this.props.vendorName:any)
        if (prevVendorName !== vendorName){
            processVendorIdByVendorName(vendorName,this.props)
        }
    }

    componentDidMount(){
        this.refreshEditData()
    }

    render(){
        const { pristine,submitting,selene,isInvalidDoc,actConfDialog,jwt,taskAcceptedInfoId,
            isOverrideVendorName,vendorName} = (this.props:any);
        const changeFieldValue = (this.props.changeFieldValue:any)
        
        if (selene.invoiceSubmitted) {
            return <Redirect to='/projectSelene/submittedForm' />;
        }
        
        return (
            <div className='container'>
                <ContainerRowReduxCheckboxField field={'isInvalidDoc'} label={'Invalid Document / Missing Pages / Not load'} />
                
                <ContainerRowReduxAutoCompleteAndOverrideField 
                    autoCompleteField={vendorNameField} 
                    autoCompleteDatasourceConfig={vendorAutoCompleteDataSourceConfig}
                    label={'Vendor Name'}
                    datas={selene.vendors}
                    checkboxField={'isOverrideVendorName'}
                    checkboxLabel={'Override this Vendor Name field'}
                    isOverride={isOverrideVendorName}
                    changeFieldValue={changeFieldValue}
                    parentProps={this.props}
                />
                {vendorName?(
                <ContainerRowReduxSmartTextReadonlyField 
                    textField={vendorIdField}
                    textLabel={'Vendor ID'}
                    isTextDisable={true}
                />
                ):null}
                
                <ContainerRowReduxTextField field={invNoField} label={'Invoice Number'} />
                <ContainerRowReduxTextField field={invDateField} label={'Invoice Date'} />
                <ContainerRowReduxTextField field={poNoField} label={'PO Number'} />
                <ContainerRowReduxTextField field={acctNoField} label={'Account Number'} />
                <ContainerRowReduxTextField field={projectNoField} label={'Project Number'}/>
                <ContainerRowReduxTextField field={termsField} label={'Terms'} />
                <ContainerRowReduxTextField field={'tax'} label={'Tax'} textType={'number'}  />
                <ContainerRowReduxTextField field={'additional'} label={'Additional'} textType={'number'}  />
                <ContainerRowReduxTextField field={'total'} label={'Total'} textType={'number'}  />
                <ContainerRowError errorMsg={selene.error} />
                
                <div className="row">
                    <div className="col-sm">
                      {renderSubmitButton(this.props)}
                    </div>
                </div>   
            </div>    
        )
    }
}

const mapStateToProps:any = (state, ownProps) => {
    const selector = ownProps.selector

    return {
        isInvalidDoc: selector(state, 'isInvalidDoc'),
        isOverrideVendorName: selector(state, 'isOverrideVendorName'),
        vendorName: selector(state, 'vendorName'),
        vendorId: selector(state, vendorIdField)
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
      getTaskData: (jwt:string,taskAcceptedInfoId:number)=>{
        dispatch(actions.getTaskData(ownProps.selene, jwt, taskAcceptedInfoId))  
      },
      populateVendorsList: (jwt:string)=>{
        dispatch(actions.populateVendorsList(jwt))  
      },
      refreshCacheValue: (key: any, value: any)=>{
        dispatch(actions.refreshCacheValue(key,value))    
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(InvoiceHeaderForm)


// WEBPACK FOOTER //
// ./src/views/ProjectSelene/InvoiceHeaderForm.js